import { useState } from "react";
import GenerateProposalModal from "./GenerateProposalModal";
import OffersModal from "./OffersModal";
import PersonalInfoModal from "./PersonalInfoModal";
import UploadFilesModal from "./UploadFilesModal";
import ProposalReviewModal from "./ProposalReviewModal";
import ProposalSubmittedModal from "./ProposalSubmittedModal";
import { useSetAtom } from "jotai";
import { currentStep } from "@/app/store";

type step =
  | "generate"
  | "offers"
  | "personalInfo"
  | "uploadFiles"
  | "proposalReview"
  | "proposalSubmitted";

interface CrefisaModalProps {
  onBack: () => void;
  onClose?: () => void;
}

export default function CrefisaModal({ onBack, onClose }: CrefisaModalProps) {
  const [step, setStep] = useState<step>("generate");
  const [personalInfoBack, setPersonalInfoBack] = useState<step>("offers");
  const setPersonalInfoStep = useSetAtom(currentStep);

  const goToPersonalInfo = (from: step) => {
    setPersonalInfoStep(0);
    setPersonalInfoBack(from);
    setStep("personalInfo");
  };

  if (step === "generate") {
    return (
      <GenerateProposalModal
        onBack={onBack}
        onContinue={() => setStep("offers")}
        onContinuePreApproved={() => goToPersonalInfo("generate")}
      />
    );
  }

  if (step === "offers") {
    return (
      <OffersModal
        onBack={() => setStep("generate")}
        onContinue={() => goToPersonalInfo("offers")}
      />
    );
  }

  if (step === "personalInfo") {
    return (
      <PersonalInfoModal
        onBack={() => setStep(personalInfoBack)}
        onContinue={() => setStep("uploadFiles")}
      />
    );
  }

  if (step === "uploadFiles") {
    return (
      <UploadFilesModal
        onBack={() => setStep("personalInfo")}
        onContinue={() => setStep("proposalReview")}
      />
    );
  }

  if (step === "proposalReview") {
    return (
      <ProposalReviewModal
        onBack={() => goToPersonalInfo("offers")}
        onContinue={() => setStep("proposalSubmitted")}
      />
    );
  }

  if (step === "proposalSubmitted") {
    return <ProposalSubmittedModal onClose={onClose} />;
  }

  return null;
}
